.pills {
  display: flex;
  gap: 8px;

  &[data-wrap] {
    flex-wrap: wrap;
  }
}

.pill {
  flex: 1 1 0;
  min-width: 0;
  height: 56px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--mantine-color-white);
  border: 1px solid var(--mantine-color-gray-4);
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  color: var(--mantine-color-gray-9);
  white-space: nowrap;
  touch-action: manipulation;
  user-select: none;
  transition:
    background 100ms ease,
    border-color 120ms ease;

  [data-mono] > & {
    font-family: var(--mantine-font-family-monospace);
  }

  /* `--pills-per-row` to a row, less the 8px gaps between them. */
  [data-wrap] > & {
    flex: 1 1 calc((100% - (var(--pills-per-row) - 1) * 8px) / var(--pills-per-row));
  }

  &:active:not(:disabled) {
    background: #f6f7f8;
  }

  &[data-active] {
    background: var(--mantine-primary-color-filled);
    border-color: var(--mantine-primary-color-filled);
    color: var(--mantine-color-white);
    font-weight: 600;
  }

  &:disabled {
    color: var(--mantine-color-gray-5);
    background: var(--mantine-color-gray-0);
    cursor: default;
  }
}
